import { useRef, lazy, Suspense } from "react";
import About from "../components/about/About";
import ContactForm from "../components/contactForm/ContactForm";
import Hero from "../components/hero/Hero";
import Highlights from "../components/highlights/Highlights";

const Project = lazy(() => import("../components/projects/Project"));
const Skills = lazy(() => import("../components/skills/Skills"));

const SectionFallback = () => (
  <div className="section-skeleton" aria-hidden="true" />
);

const Main = () => {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div>
      <Hero onClick={scrollToContact} />
      <About />
      <Highlights />
      <Suspense fallback={<SectionFallback />}>
        <Project />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Skills />
      </Suspense>
      <ContactForm contactRef={contactRef} />
    </div>
  );
};

export default Main;
